import React from "react";
import { Navigate } from "react-router-dom";
import { usePermissions } from "./PermissionProvider";
import { LOGIN } from "../Router/path";

export function ProtectedRoute({ permission, children, redirect = LOGIN }) {
  const { permissions } = usePermissions();

  if (!permissions) return null;

  return permissions.includes(permission) ? (
    children
  ) : (
    <Navigate to={redirect} />
  );
}
